import Vue from 'vue'
import Vuex from 'vuex'

import download from './download'
import userSettings from './userSettings'
import reports from './reports'
import summaries from './summaries'
import profile from './profile'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hash: '',
    lang: 'az',
    windowWidth: window.innerWidth,
    loader: false,
    localTranslation: {},
    time: null
  },
  mutations: {
    initializeState(state) {
      if (localStorage.getItem('data')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('data')))
        )
      }
    },
    startLoader(state) {
      state.loader = true
    },
    stopLoader(state) {
      state.loader = false
    },
    setWindowWidth(state) {
      let width = window.innerWidth

      if (width > 1279) {
        state.windowWidth = 'desktop'
      } else {
        state.windowWidth = 'mobile'
      }
    }
  },
  actions: {
    
  },
  modules: {
    download,
    userSettings,
    reports,
    summaries,
    profile
  }
})